import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=0b2923e7&scoped=true&"
import script from "./mark.vue?vue&type=script&lang=js&"
export * from "./mark.vue?vue&type=script&lang=js&"
import style0 from "./mark.vue?vue&type=style&index=0&id=0b2923e7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2923e7",
  null
  
)

export default component.exports